<template>
  <div class="content">
    <a v-if="params.data.TransactionStatus != 'Declined'"
       @click="OpenReconcile"
       style="text-decoration: underline; cursor: pointer"
       v-tooltip.bottom="'Open ' + params.value">
      {{params.data.TransactionNumber}}
    </a>
    <span v-else>{{params.data.TransactionNumber}}</span>
  </div>
</template>

<script>

import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export default {
  methods: {
    OpenReconcile() {
      EventBus.$emit(events.EVEDPAY_CARDS.OPEN_RECONCILE, this.params.data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/OpenReconcile.vue